import {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import ContactShow from './contact-show';
import ContactForm from './contact-form';

function ContactPage() {
  const navigate = useNavigate();
  const {contactId} = useParams();
  const isNew = contactId === 'new';
  const [mode, setMode] = useState(isNew ? 'edit' : 'show');
  // Used to force-remount ContactShow after a successful save so it refetches the contact.
  const [reloadKey, setReloadKey] = useState(0);

  // Reset to show mode when the URL contactId changes (e.g. after creating a
  // new contact and navigating to /contacts/:id, or when switching contacts).
  useEffect(() => {
    if (!isNew) setMode('show');
  }, [contactId, isNew]);

  const goToList = () => navigate('/contacts');

  if (isNew) {
    return (
      <ContactForm
        contactId="new"
        onCancel={goToList}
        onSaved={(saved) => {
          if (saved?.id) navigate(`/contacts/${saved.id}`);
          else goToList();
        }}
      />
    );
  }

  if (mode === 'show') {
    return (
      <ContactShow
        key={`show-${reloadKey}`}
        contactId={contactId}
        onEdit={() => setMode('edit')}
        onContactList={goToList}
      />
    );
  }

  return (
    <ContactForm
      contactId={contactId}
      onCancel={() => setMode('show')}
      onSaved={() => {
        setReloadKey(k => k + 1);
        setMode('show');
      }}
    />
  );
}

export default ContactPage;
